import { Surface, Txt } from '@vst/beam';
import { FeesAndDiscounts } from '@buy-viasat/types/build/bv';
import { priceDecimalFormat } from '@buy-viasat/utils';
import { FeesAndDiscountsKind } from '../../types';
import styles from './upfrontFees.module.scss';

export type UpfrontFeesProps = {
  feesAndDiscounts: FeesAndDiscounts[];
  locale: string;
  currencySymbol: string;
  freeLabel: string;
};

export const UpfrontFees = ({ feesAndDiscounts, locale, currencySymbol, freeLabel }: UpfrontFeesProps) => (
  <>
    {feesAndDiscounts.map((feeDiscount) => {
      const feeDiscountTotal = feeDiscount.total;
      const hasDiscount = (feeDiscount.discount ?? 0) < 0;
      const isActivationFee = feeDiscount.kind === FeesAndDiscountsKind.ACCOUNT_SETUP;
      const isFree = (feeDiscountTotal ?? 0) === 0 && !isActivationFee;

      return (
        <Surface
          className={styles['additionalFees']}
          data-testid="installationFee"
          pb="8px"
          pt="4px"
          key={`additionalFees-${feeDiscount.name}`}
        >
          <Txt variant="bodySmallRegular" color="subtle">
            {feeDiscount.name}
          </Txt>
          <Surface className={hasDiscount ? styles['planPrice'] : styles['noPromo']} data-testid="planPriceSurface">
            <Txt
              variant="bodySmallBold"
              color={isFree || hasDiscount ? 'success' : 'inherit'}
              data-testid={isFree ? 'freeFee' : 'installationFeeWithPromo'}
              className={styles['installationFeeWithPromo']}
            >
              {isFree ? freeLabel : priceDecimalFormat(feeDiscountTotal ?? '--', locale, currencySymbol)}
            </Txt>
            {hasDiscount && (
              <Txt variant="bodySmallItalic" className={styles['strikethrough']} color="subtle">
                {priceDecimalFormat(feeDiscount.fee ?? '--', locale, currencySymbol)}
              </Txt>
            )}
          </Surface>
        </Surface>
      );
    })}
  </>
);
